{
  "record": "Class",
  "index": {
    "title": "Classes",
    "create": "Create Class",
    "empty_list_title": "No Classes",
    "empty_list_description": "Click the create button to create your first class.",
    "num_offered_one": "{{count}} class offered",
    "num_offered_other": "{{count}} classes offered",
    "availability": "Availability",
    "hours_per_week": "{{hours}} hours per week",
    "set_availability": "Set Availability",
    "go_live": "Go Live",
    "students": "Students",
    "transfers": "Transfers"
  },
  "new": {
    "page_title": "New Class",
    "submit": "Create Class",
    "class_scope": {
      "label": "Class Scope",

      "team_label": "Team Profile",
      "team_description": "List this class as part of a team. Other teachers in the team will be able to give the class.",

      "personal_label": "Personal Profile",
      "personal_description": "List this class under your personal profile."
    },

    "team_select": {
      "label": "Team",
      "placeholder": "Select team"
    }
  },
  "students": {
    "title": "Students",
    "empty_list_title": "No Students",
    "empty_list_description": "Student records will be displayed once the class has reached the 'live' status.",
    "priority_title": "Priority {{rank}} #{{instance}}",
    "view_student": "View Student",
    "sessions_one": "{{count}} Session",
    "sessions_other": "{{count}} Sessions"
  }
}
